<template>
    <div class="fiveImageList">
        <div class="indexContainer">
            <el-divider class="indexTitle" v-if="val.title">
                <div class="indexTitleMain">
                    <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br/>
                    <h4>{{val.summary}}</h4>
                </div>
            </el-divider>
            <el-container>
                <el-row :gutter="10" style="width:100%">
                    <el-col :xs="12" :sm="4" v-for="(item,index) in newList" :key="index" style="margin-bottom:10px;">
                        <a href="javascript:void(0);" class="cardListImg"  @click="rowClick(item)">
                            <img :src="item.imgUrl" :alt="item.imgAlt">
                            <p>{{ item.title }}</p>
                        </a>
                    </el-col>
                </el-row>
            </el-container>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        val: {}
    },
    data(){
        return{
            newList:[],
        }
    },
    methods:{
        rowClick(row){
            if(row.linkUrl){
                window.open(row.linkUrl, '_self');
            }else{
                this.$refs.img.open(row);
            }
        },
    },
    created() {
        this.newList = this.val.attaches;
    },
    watch: {
      val(val) {
        this.newList = this.val.attaches;
      }
    }
}
</script>
<style lang="less" scoped>
.fiveImageList{
    /deep/.el-col{
        width: 50%;
    }
    .cardListImg{
        border-radius: 4px;
        width: 100%;
        position: relative;
        overflow: hidden;
        border-radius: 4px;
        box-sizing: border-box;
        display: inline-table;
        img{
            width: 100%;
            display: block;
            border-radius: 4px;
            border: 1px solid #eee;
            height: 112px;
        }
        p{
            margin: 0 ;
            line-height: 36px;
            font-size: 14px;
            font-weight: normal;
            display: inline-block;
            width: 100%;
            overflow: hidden; /*隐藏*/
            white-space: nowrap;  /*不换行*/
            text-overflow: ellipsis;  /* 超出部分省略号 */

        }
    }
    .cardListImg:hover{
        color: #d11a2e;
        img{
            box-shadow: 0 0 3px rgba(0,0,0,.2);
        }
    }

    @media only screen and (min-width: 768px){
        /deep/.el-col{
            width: 20%;
        }
        .cardListImg{
            font-size: 16px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/item/patch22.vue